import {useEffect, useState} from "react";

export const useTableScroll = () => {
    const [isLeftDisabled, setIsLeftDisabled] = useState(true);
    const [isRightDisabled, setIsRightDisabled] = useState(false);

    const checkScrollPosition = (container) => {
        setIsLeftDisabled(container.scrollLeft - 1 <= 0);
        setIsRightDisabled((container.scrollLeft + container.clientWidth + 1) >= container.scrollWidth);
    };

    const handleScroll = (event) => {
        const container = event.target;
        const scrollAmount = event.deltaY;
        container.scrollTo({
            top: 0,
            left: container.scrollLeft + scrollAmount,
            behavior: 'smooth',
        });
        checkScrollPosition(container);
    };

    const scrollLeft = () => {
        const container = document.querySelector('.travel-table-container');
        container.scrollBy({
            top: 0,
            left: -150,
            behavior: 'smooth',
        });
        checkScrollPosition(container);
    };

    const scrollRight = () => {
        const container = document.querySelector('.travel-table-container');
        container.scrollBy({
            top: 0,
            left: 150,
            behavior: 'smooth',
        });
        checkScrollPosition(container);
    };

    useEffect(() => {
        const container = document.querySelector('.travel-table-container');
        const handleScroll = (event) => {
            checkScrollPosition(container);
        };
        container.addEventListener('scroll', handleScroll);
        return () => {
            container.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return {
        isLeftDisabled,
        isRightDisabled,
        handleScroll,
        scrollLeft,
        scrollRight,
    }
}